// components/layout/NavItem.jsx
import React from 'react';

const NavItem = ({ icon, label, isActive, isCollapsed, onClick, highlight = false }) => {
    const getClassName = () => {
        if (isActive && highlight) {
            return 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg';
        }
        if (highlight) {
            return 'bg-gradient-to-r from-blue-50 to-purple-50 hover:from-blue-100 hover:to-purple-100 border-2 border-blue-200';
        }
        if (isActive) {
            return 'bg-blue-50 text-blue-600';
        }
        return 'hover:bg-gray-100';
    };

    const getIconClassName = () => {
        if (isActive && highlight) {
            return 'text-white';
        }
        if (highlight) {
            return 'text-blue-600';
        }
        if (isActive) {
            return 'text-blue-600';
        }
        return 'text-gray-600';
    };

    const getLabelClassName = () => {
        if (isActive && highlight) {
            return 'font-bold text-white';
        }
        if (highlight) {
            return 'font-semibold text-blue-600';
        }
        if (isActive) {
            return 'font-medium';
        }
        return 'text-gray-600';
    };

    return (
        <button
            onClick={onClick}
            className={`w-full flex items-center gap-3 p-2 rounded-lg mb-1 transition-all ${getClassName()}`}
        >
            <div className={getIconClassName()}>
                {icon}
            </div>
            {!isCollapsed && (
                <span className={getLabelClassName()}>
                    {label}
                    {highlight && !isActive && <span className="ml-2 text-xs">✨</span>}
                </span>
            )}
        </button>
    );
};

export default NavItem;